const getLeaderBoardPlacement = ({ allUsers, allQuizMark, allAssignmentMark, user }) => {
    let uniqResult = []
    allUsers?.forEach(singleUser => {
        const filterById = single => single.student_id === singleUser.id
        const sumMark = (pre, current) => {
            return parseFloat(current.mark) + pre
        }
        // assignmentMark
        const singleUserAssignments = allAssignmentMark.filter(filterById)
        const singleUserTotalAssignmentMark = singleUserAssignments.reduce(sumMark, 0)

        // quiz mark
        const singleUserQuizzes = allQuizMark.filter(filterById)
        const singleUserTotalQuizMark = singleUserQuizzes.reduce(sumMark, 0)

        uniqResult = [...uniqResult, { id: singleUser.id, name: singleUser.name, quizMark: singleUserTotalQuizMark, assignmentMark: singleUserTotalAssignmentMark, total: singleUserTotalAssignmentMark + singleUserTotalQuizMark }]


    });
    const sorting = uniqResult.sort((a, b) => a.total - b.total).reverse()

    const placements = sorting.reduce((pre, current, i) => {
        let value = 0;
        if (i === 0) {
            return [{ ...current, placement: 1 }]
        }
        else if (pre[i - 1].total === current.total) {
            value = pre[i - 1].placement
        } else {
            value = pre[i - 1].placement + 1
        }
        return [
            ...pre,
            {
                ...current,
                placement: value,
            }
        ]
    }, [{ placement: 0 }])

    let ownUserPlacement = {};
    if (user.role === 'student') {

        ownUserPlacement = placements.find(single => single.id === user.id)
    }
    const top20Result = placements.filter(single => single.placement <= 20)
    return {
        placements: top20Result,
        ownUserPlacement,
    }
}
export default getLeaderBoardPlacement